module.exports = "<div class=\"snack-bar visible\">\n    {{message}}\n</div>"